import React, { useState } from 'react';
import { Box, Button, Flex, Heading, Input, Text, Textarea } from '@chakra-ui/react';
import axios from 'axios';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose }) => {
  const [feedback, setFeedback] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmit = async () => {
    if (!feedback.trim()) {
      return;
    }
    
    setIsSubmitting(true);
    try {
      // Send feedback to the backend
      await axios.post('/api/diy/feedback', { 
        feedback: feedback.trim(),
        email: email.trim() || null 
      });
      
      setFeedback('');
      setEmail('');
      onClose();
    } catch (error) {
      console.error('Error submitting feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  if (!isOpen) return null;
  
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0,0,0,0.5)"
      zIndex="1000"
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={onClose}
    >
      <Box
        bg="white"
        borderRadius="lg"
        p={6}
        maxWidth="500px"
        width="90%"
        onClick={(e) => e.stopPropagation()}
        boxShadow="xl"
      >
        <Heading size="md" mb={4}>Send Feedback</Heading>
        <Text mb={4}>
          Thank you for taking the time to provide feedback! Please share your thoughts, suggestions, or any issues you've experienced with the app.
        </Text>
        
        <Textarea
          placeholder="Your feedback"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          mb={4}
          height="120px"
          resize="vertical"
          borderColor="var(--gray-300)"
          _focus={{ borderColor: 'var(--brand-secondary)', boxShadow: '0 0 0 1px var(--brand-secondary)' }}
        />
        
        <Input
          type="email"
          placeholder="Your email (optional)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          mb={4}
          borderColor="var(--gray-300)"
          _focus={{ borderColor: 'var(--brand-secondary)', boxShadow: '0 0 0 1px var(--brand-secondary)' }}
        />
        
        <Flex justifyContent="flex-end" gap={3}>
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!feedback.trim() || isSubmitting}
            bg="var(--brand-secondary)"
            color="white"
            _hover={{ bg: 'var(--brand-dark)' }}
          >
            {isSubmitting ? 'Sending...' : 'Submit Feedback'}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default FeedbackModal;
